import { dateExactMatcher } from "../dateExactMatcher";
import dateMatcher from "../dateMatcher";
import {
  getActiveBranchIds1,
  getBranchInfobyId,
} from "../multipleBranch/getActiveBranchId";

export function reportLineChartGen(data, dates) {
  
  if (dates == null || data == null || data.length == 0) return null;
  const activeBranches = getActiveBranchIds1();

  const d1 = dataExtractorLineChartReporting(data, dates, activeBranches);
  // Extracting data that fits our criteria of rating 5 or 1 and belongs to active branches only.
  // const d2 = dataReducerLineChartReporting(d1, dates, activeBranches);
  // console.log(d2);
  // return d2;

  const d2 = dataReducerForLineChartReporting2(d1, dates, activeBranches);

  const d3 = dataFormatterLineChartReport(d2, dates, activeBranches);
  return d3;
}

function dataReducerForLineChartReporting2(data, dates, activeBranches) {
  if (data.length == 0) return null;
  //output of this funciton
  /**
   output = [
   {rating:1,data : [{branch:"GK",bData:{date:"12/11",count:3},{branch:"GK",bData:{date:"12/11",count:3}}]}]
   */

  let ratingObj1 = {
    rating: 1,
    data: [],
  };
  let ratingObj5 = {
    rating: 5,
    data: [],
  };

  // reducing data for Rating 1
  activeBranches.forEach((bId) => {
    let branchObj1 = { branch: getBranchInfobyId(bId).name, bData1: [] };
    let branchObj5 = { branch: getBranchInfobyId(bId).name, bData1: [] };

    for (let i = 0; i < data.length; i++) {
      let temp = {};
      if (data[i].rating == 1 && data[i].admin_id == bId) {
        temp.bId = data[i].admin_id;
        temp.createdDate = data[i].createdAt;
        branchObj1.bData1.push(temp);
      } else if (data[i].rating == 5 && data[i].admin_id == bId) {
        temp.bId = data[i].admin_id;
        temp.createdDate = data[i].createdAt;
        branchObj5.bData1.push(temp);
      }
    }
    ratingObj1.data.push(branchObj1);
    ratingObj5.data.push(branchObj5);
  });

  return [ratingObj1, ratingObj5];
}

function dataFormatterLineChartReport(data, dates, activeBranches) {
  // REMOVE THIS REVEERSE CODE WHEN ACTUAL DATA IS BEING SUPPLIED.
if(data == null){
  return null;
}
  const allDatesNLabels = getAllDatesBetweenTwoDates(dates);
  let diffOfDays = allDatesNLabels.diff;
  let output = [];
  data.forEach((d1) => {
    // d1 = {rating: 1 , data :[{branch , bData1 :[ {createdAt:..}]}]}
    let mainObj = { rating: d1.rating, data: [] };

    d1.data.forEach((branchLevel) => {
      // branchLevel = {branch:"GK", bData1 : [bId,createdDate]}
      let branchObj = { branch: branchLevel.branch, bData: [] };

      // we loop for each date Label
      allDatesNLabels.outputDates.forEach((date, index) => {
        // inside Date label loop we again loop dataObject to creaate count frequency

        let count = 0;
        let dateCountObj = {
          date: allDatesNLabels.outputLabels[index],
          count: 0,
        };
        branchLevel.bData1.forEach((dateLevel) => {
          // dateLevel = {bId, createdDate}

          if (dateExactMatcherForReport(dateLevel.createdDate, date)) {
            count++;
          }
        });
        dateCountObj.count = count;
        branchObj.bData.push(dateCountObj);
      });
      mainObj.data.push(branchObj);
    });
    output.push(mainObj);
  });
  return output;
}

function dataExtractorLineChartReporting(data, dates, activeBranches) {
  if (data.length == 0) return null;
  // here dates is array to two dates - from and till.
  //data is feedback data, we filter data with bId as admin_Id
  // and rating as 1 or 5.
  // activeBranches - array of active branches.

  // we use breakDate(fromDate) so that we come  out of loop stops beyond a date
  // since we need data for certain number of days only.

  let fromDate = new Date(dates[0]);

  let tillDate = new Date(dates[1]);

  const d1 = [];

  for (let i = 0; i < data.length; i++) {
    let createdDate = new Date(data[i].createdAt);

    if (
      (activeBranches.includes(data[i].admin_id) && data[i].rating == 1) ||
      data[i].rating == 5
    ) {
      d1.push(data[i]);
    }
    if (fromDate > createdDate) break;
  }

  return d1;
}

// this function creates counst of rating frequency of 5 or 1.
//this is done per branch
function dataReducerLineChartReporting(data1, dates, activeBranches) {
  if (data1.length == 0) return null;
  //output of this funciton
  /**
   output = [
   {rating:1,data : [{branch:"GK",bData:{date:"12/11",count:3},{branch:"GK",bData:{date:"12/11",count:3}}]}]
   */
  const allDatesNLabels = getAllDatesBetweenTwoDates(dates);

  let diffOfDays = allDatesNLabels.diff;

  // this below array takes in how many n which star rating we want to create dta.
  let ratingArrayForGraph = [5, 1];
  // this array stores all rating for which we need to calculate data.

  let output = [];
  let loopCount = 0;

  ratingArrayForGraph.forEach((rating) => {
    let obj = {
      rating,
      data: [],
    };

    let data = [];
    activeBranches.forEach((bId) => {
      let branchObj = {
        branch: getBranchInfobyId(bId).name,
        bData: [],
      };

      let bData = [];
      allDatesNLabels.outputDates.forEach((d, index) => {
        let obj = {
          date: allDatesNLabels.outputLabels[index],
          count: 0,
        };
        let count1 = 0;
        data1.forEach((dataItem) => {
          // console.log("loop iteration ", loopCount);
          // loopCount++;
          // console.log(data1.length);
          let createdDate = new Date(
            new Date(dataItem.createdAt).toDateString()
          );

          if (
            dataItem.rating == rating &&
            dataItem.admin_id == bId &&
            dateExactMatcherForReport(createdDate, d)
          ) {
            count1++;
          }
        });
        obj.count = count1;
        bData.push(obj);
      });
      branchObj.bData = [...bData];
      data.push(branchObj);
    });
    obj.data = [...data];
    output.push(obj);
  });

  // let d1 = new Date(2024, 11, 11);
  // let d2 = "12/11/2024";
  // let output = dateExactMatcherForReport(d1, d2);
  // console.log(output);
  return output;
}

// function dataReducerForLineChartReporting1(data, dates, activeBranches) {
//   if (data.length == 0) return null;
//   //output of this funciton
//   /**
//    output = [
//    {rating:1,data : [{branch:"GK",bData:{date:"12/11",count:3},{branch:"GK",bData:{date:"12/11",count:3}}]}]
//    */
//   const allDatesNLabels = getAllDatesBetweenTwoDates(dates);
//   let diffOfDays = allDatesNLabels.diff;

//   allDatesNLabels.rating1 = [];
//   allDatesNLabels.rating5 = [];

//   console.log("======================================================");
//   console.log(data);

//   // REMOVE THIS REVERSE CODE LINE WHEN ACTUAL DATA IS CONNECTED
//   data.reverse();
//   let dateIndex = 0;
//   let dataIndex = 0;

//   let loopBreak = 0;
//   let whileLoopCounter = 0;
//   let rating1Counter = 0;
//   let rating5Counter = 0;
//   while (loopBreak == 0) {
//     whileLoopCounter++;
//     let createdDate = new Date(data[dataIndex].createdAt);
//     let labelDate = allDatesNLabels.outputDates[dateIndex];

//     if (dateExactMatcherForReport(createdDate, labelDate)) {
//       if (data[dataIndex].rating == 1) rating1Counter++;
//       if (data[dataIndex].rating == 5) rating5Counter++;

//       console.log("matching bbbbbbbbbbbbbbb", data[dataIndex].rating);
//       console.log(data[dataIndex].createdAt);

//       if (dataIndex < data.length - 1) {
//         dataIndex++;
//       } else {
//         if (dateIndex < allDatesNLabels.outputDates.length - 1) {
//           dateIndex++;
//           dataIndex = 0;
//         } else {
//           loopBreak = 1;
//         }
//       }
//     } else {
//       console.log("not matching date", data[dataIndex].createdAt);
//       allDatesNLabels.rating1[dateIndex] = rating1Counter;
//       allDatesNLabels.rating5[dateIndex] = rating5Counter;
//       if (dataIndex < data.length - 1) {
//         dataIndex++;
//         rating1Counter = 0;
//         rating5Counter = 0;
//       } else {
//         if (dateIndex < allDatesNLabels.outputDates.length - 1) {
//           dateIndex++;
//           dataIndex = 0;
//           rating1Counter = 0;
//           rating5Counter = 0;
//         } else {
//           loopBreak = 1;
//         }
//       }
//     }

//     if (whileLoopCounter > 10000) {
//       loopBreak = 1;
//       console.log(whileLoopCounter);
//     }
//   }
//   console.log(whileLoopCounter);
//   console.log(allDatesNLabels);
// }

export function getAllDatesBetweenTwoDates(dates) {
  //console.log(dates);
  if (dates == null) return null;
  //this funciton accepts an arrya of 2 dates from n til and returns
  // object of 2 array one contains date label (like 11/12) and another contains dates
  // both between 2 dates passed to function; and also return diff of days btwn two dates.
  let dateFrom = dates[0];
  let dateTill = dates[1];
  //console.log(dateTill);
  //console.log((dateTill - dateFrom + 1000) / (3600000 * 24));
  let diffOfDays = (dateTill - dateFrom + 1000) / (3600000 * 24);
  const outputDates = [];
  const outputLabels = [];
  for (let i = 0; i < diffOfDays; i++) {
    let tDate = new Date(
      dateTill.getFullYear(),
      dateTill.getMonth(),
      dateTill.getDate() - i
    );

    let tempDateString = tDate.toLocaleDateString("en-in").split("/");
    outputLabels.push(` ${tempDateString[0]}/${tempDateString[1]}`);
    outputDates.push(tDate);
  }
  return { diff: diffOfDays, outputDates, outputLabels };
}

export function dateExactMatcherForReport(d1, d2) {
  if (d1 == undefined || d2 == undefined) return false;

  let date1 = d1;
  let date2 = d2;

  if (typeof d1 == "string") {
    date1 = new Date(d1);
  }
  if (typeof d2 == "string") {
    date2 = new Date(d2);
  }

  return date1.toLocaleDateString() == date2.toLocaleDateString();
}
